import React from 'react'
import { useQuery } from '@apollo/client'

import { ContentLoaderTableOnly } from '../../../components/loader/loader.component'
import TableComponent from '../../../components/table/table.component'
import LabelComponent from '../../../components/label/label.component'
import LinkComponent from '../../../components/link/link.component'

import { ActionContainer, SortingContainer } from '../admin.styles'

import { GET_MENU_ORDER_LIST } from '../../../config/graphql'

const MenuOrderList = ({ dateRange, groupFilter }) => {
    console.log({ variables: {...dateRange, ...groupFilter} })
    const { loading, data } = useQuery(GET_MENU_ORDER_LIST, { variables: {...dateRange, ...groupFilter} });
    console.log(data);
    const dataMenuOrder = data?.menuOrders || [];
    console.log(dataMenuOrder);
    
    let currency = Intl.NumberFormat('id', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    if (loading && !dataMenuOrder.length) {
      return <ContentLoaderTableOnly />
    } else {
      var idx = 0;
      return <div style={{marginTop: '2em'}}>
        <TableComponent mode='custom' template='1fr 2fr 2fr 2fr 2fr 1fr 1fr 1fr 1fr'>
          <div aria-label='head'>
            <div>
              <SortingContainer>No</SortingContainer>
            </div>
            <div>
              <SortingContainer>Tanggal</SortingContainer>
            </div>
            <div>
              <SortingContainer>ID Kasir</SortingContainer>
            </div>
            <div>
              <SortingContainer>Toko</SortingContainer>
            </div>
            <div>
              <SortingContainer>Nama Item</SortingContainer>
            </div>
            <div>
              <SortingContainer>Jumlah</SortingContainer>
            </div>
            <div>
              <SortingContainer>Harga Satuan</SortingContainer>
            </div>
            <div>
              <SortingContainer>Harga Total</SortingContainer>
            </div>
            <div>
              <SortingContainer>Order ID</SortingContainer>
            </div>
          </div>
          <div aria-label='body'>
            {dataMenuOrder.flatMap((menu_order) => {
              return menu_order.items.map((item) => {
                idx++;
                return (
                  <div key={idx}>
                    <div>
                      <LabelComponent mode='tagredmobile'>NO</LabelComponent>
                      {idx}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Tanggal</LabelComponent>
                      {(new Date(Date.parse(menu_order.createdAt))).toLocaleDateString('id', { year: 'numeric', month: 'short', day: 'numeric' })} - {(new Date(Date.parse(menu_order.createdAt))).toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' })}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>ID Kasir</LabelComponent>
                      {menu_order.foodVendor.deviceId}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Toko</LabelComponent>
                      {menu_order.foodVendor.name}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Nama Item</LabelComponent>
                      {(item.name)}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Jumlah</LabelComponent>
                      {item.quantity}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Harga Satuan</LabelComponent>
                      {currency.format(item.price)}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Harga Total</LabelComponent>
                      {currency.format(item.quantity * item.price)}
                    </div>
                    <div>
                      <LabelComponent mode='tagredmobile'>Order ID</LabelComponent>
                      {`#${menu_order.id}`}
                    </div>
                  </div>
                )
              })
            })}
          </div> 
        </TableComponent>
      </div>
    }
}

export default MenuOrderList;